"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Event = void 0;
var stringReplace_1 = require("./util/stringReplace");
var Event = /** @class */ (function () {
    function Event(eventName, payload) {
        this.eventName = eventName;
        this.payload = payload;
        this.uid = "uid_" + String(++Event.lastUid);
    }
    Event.prototype.resume = function () {
        return {
            action: typeof this.eventName === 'string'
                ? Event.notNull(this.eventName)
                : Event.composeAction(this.eventName),
            payload: this.payload,
        };
    };
    Event.composeAction = function (_a) {
        var application = _a.application, event = _a.event, type = _a.type;
        return "" + Event.notNull(application, '-') + Event.notNull(event, '-') + Event.notNull(type);
    };
    Event.notNull = function (value, concat) {
        if (concat === void 0) { concat = ''; }
        return value ? "" + stringReplace_1.stringReplace(value) + concat : '';
    };
    Event.destroy = function () {
        this.lastUid = 0;
    };
    Event.lastUid = 0;
    return Event;
}());
exports.Event = Event;
